const SQLITE_CORRUPTION_MESSAGE_PATTERN =
  /SQLITE_CORRUPT|database disk image is malformed|short read on page \d+/i;
export class DatabaseRecoveryRequiredError extends Error {
  constructor(cause?: unknown) {
    super("Study database needs verified recovery. Existing files have been preserved.", { cause });
    this.name = "DatabaseRecoveryRequiredError";
  }
}

/** Only structural corruption, never transient network/busy/full-disk errors. */
export function isDatabaseCorruption(error: unknown): boolean {
  let current = error;
  for (let depth = 0; depth < 10; depth += 1) {
    if (typeof current === "string") {
      return SQLITE_CORRUPTION_MESSAGE_PATTERN.test(current);
    }
    if (typeof current !== "object" || current === null) {
      return false;
    }
    if (Reflect.get(current, "name") === "DatabaseRecoveryRequiredError") {
      return true;
    }
    const message: unknown = Reflect.get(current, "message");
    if (typeof message === "string" && SQLITE_CORRUPTION_MESSAGE_PATTERN.test(message)) {
      return true;
    }
    current = Reflect.get(current, "cause");
  }
  return false;
}
